app.factory("Lecturer", ["$http",
    function ($http) {
        var Lecturer = {};

        Lecturer.fetchOne = function (lecturer) {
            return $http.get("/lecturer/one/" + lecturer).then(function (resp) {
                return resp.data;
            });
        };

        Lecturer.list = function (params) {
            params = params || {};
            params.limit = params.limit || 10;
            return $http.get("/lecturer/list", {
                params: {
                    page: params.page,
                    limit: params.limit,
                    query: params.query,
                    faculty: params.faculty,
                    activeState: params.activeState
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        Lecturer.create = function (params) {
            return $http.post("/lecturer/add", {
                user: params.user,
                faculty: params.faculty,
                rank: params.rank
            }).then(function (resp) {
                return resp.data;
            });
        };

        Lecturer.remove = function (userId) {
            return $http.post("/lecturer/remove", {
                userId: userId
            }).then(function (resp) {
                return resp.data;
            });
        };

        Lecturer.edit = function (lecturer) {
            return $http.post("/lecturer/update", lecturer)
        };

        Lecturer.exportList = function (params) {
            var url = "/lecturer/list/export?";

            for (var i in params) {
                if (typeof params[i] === 'string')
                    url += i + "=" + params[i] + "&"
                else params[i].forEach(function (m) {
                    url += i + "=" + m + "&"
                })
            }
            url = url.substr(0, url.length - 1);
            window.open(url)
        };

        Lecturer.analytics = function (params) {
            var url = "/lecturer/list/export/analytics?";

            for (var i in params) {
                if (typeof params[i] === 'string')
                    url += i + "=" + params[i] + "&"
                else params[i].forEach(function (m) {
                    url += i + "=" + m + "&"
                })
            }
            url = url.substr(0, url.length - 1);
            window.open(url)
        };

        Lecturer.listForQuestionnaire = function (params) {
            var url = "/lecturer/list/questionnaire?";
            for (const [key, value] of Object.entries(params)) {
                if(value) url += key + "=" + value + "&";
            }
            return $http.get(url).then(function (resp) {
                return resp.data;
            });
        }

        return Lecturer;
    }
]);
